import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'components/shared/Layout';
import HotelsReviewBooking from './HotelsReviewBooking';

import { StyledExtrasContainer } from './ExtrasHotels.styles';
import { hasHotels } from '../BookingPathReviewBookingSummary.utils';

const ExtrasHotel = ({ hotels, bookingReference }) => (
  <Row span={16} start={1}>
    {hasHotels(hotels) && (
      <StyledExtrasContainer>
        {hotels.map((hotel) => {
          if (!hotel.cancelled) {
            return (
              <HotelsReviewBooking
                key={hotel.jacTravelRef || `${hotel.eurostarReference}_${hotel.bookerSurname}`}
                hotel={hotel}
                bookingReference={bookingReference}
              />
            );
          }

          return null;
        })}
      </StyledExtrasContainer>
    )}
  </Row>
);

ExtrasHotel.propTypes = {
  bookingReference: PropTypes.string.isRequired,
  hotels: PropTypes.arrayOf(
    PropTypes.shape({
      cancelled: PropTypes.bool,
      passenger: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      }),
      checkInDate: PropTypes.string,
      jacTravelRef: PropTypes.string,
      hotelId: PropTypes.string,
      eurostarReference: PropTypes.string,
      currency: PropTypes.string,
      price: PropTypes.number,
      itemRef: PropTypes.string.isRequired
    })
  )
};

export default ExtrasHotel;
